import { render, staticRenderFns } from "./checkPackagesModal.vue?vue&type=template&id=24cd6aab&scoped=true"
import script from "./checkPackagesModal.vue?vue&type=script&lang=js"
export * from "./checkPackagesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cd6aab",
  null
  
)

export default component.exports